import { KAS_HOST, prependKasUrl } from "server/kas/utils";

export interface NGCMeResponse {
  user?: {
    blocked?: boolean;
    verified?: boolean;
  };
}

async function ngcFetch<T>(
  endpoint: string,
  method: "GET" | "POST",
  signal?: AbortSignal,
): Promise<T> {
  const response = await fetch(prependKasUrl(endpoint), {
    headers: { host: KAS_HOST },
    credentials: "include",
    method,
    signal,
  });

  if (!response.ok) {
    throw new Error(`NGC request failed: ${response.status}`);
  }

  return response.json();
}

export function getNgcMe(signal?: AbortSignal) {
  return ngcFetch<NGCMeResponse>("/v2/users/me", "GET", signal);
}

export function requestNgcUserVerification(signal?: AbortSignal) {
  return ngcFetch<unknown>("/v3/users/me/verify", "POST", signal);
}
